import KeenSlider from "keen-slider";
import Logger from "../lib/logger";

/**
 * Theme Full Background Carousel --- A class to create a Carousel with a full image background
 * @author Vincent V. Toscano
 */
class ThemeFullBackgroundCarousel {
	static EVTS = {
		NEXT: 'carousel_next',
		PREVIOUS: 'carousel_previous'
	};

	constructor(carousel_container = '.theme-full-background-carousel', carousel_individual_slide_class_name = '.theme-full-background-carousel__slide', carousel_next_prev_class_name = '.theme-full-background-carousel-controls__button') {
		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this._name = 'THEME FULL BACKGROUND CAROUSEL';
		Logger.info(`${this._name} > init`);
		this._dom_obj = document.createElement("i");
		this._prev    = document.querySelector(`${carousel_next_prev_class_name}[data-rel="prev"]`);
		this._next    = document.querySelector(`${carousel_next_prev_class_name}[data-rel="next"]`);
		this._slider  = new KeenSlider(
			`${carousel_container}`,
			{
				drag: true,
				loop: true,
				mode: "free-snap",
				selector: `${carousel_individual_slide_class_name}`,
				slides: {
					perView: 1
				},
				defaultAnimation: {
					duration: 1400
				},
				// breakpoints: {
				// 	'(min-width: 0px) and (max-width: 719px)': {
				// 		slides: {
				// 			perView: 1,
				// 			spacing: 16
				// 		}
				// 	}
				// },
				animationEnded: (evt) => {
					// console.info(`${this._name} > Slider > animationEnded > Animation has ended`, evt);
					/**
					 * Here is where we'd set the current slide
					 */
					/*
					 const slide_current = evt.slides[evt.track?.details?.rel];
					 slide_current.setAttribute('data-slide-current', 'true');
					 slide_current.style.transform = slide_current.style.transform + ' scale(1.4)';
					 */
				},
				created: (evt) => {
					console.info(`${this._name} > Slider > created > Slider has been created`);
					this.addHandlers();
				},
				detailsChanged: (evt) => {
					// console.info(`${this._name} > Slider > detailsChanged > The details-property has changed. At each movement, after an option change, and at each initialization or resizing`);
				},
				optionsChanged: (evt) => {
					// console.info(`${this._name} > Slider > optionsChanged > Options have changed, e.g. due to an update, resizing(when the number of slides changes) or a change of the breakpoint`);
				},
				slideChanged: (evt) => {
					// console.info(`${this._name} > Slider > slideChanged > Active or most visible slide has changed`, evt.track?.details?.rel);
					// console.info(evt.slides[evt.track?.details?.rel].style.transform);
				},
				updated: (evt) => {
					// console.info(`${this._name} > Slider > updated > the update function was called due to a size change or other trigger`, evt);
				},
			}
		)
	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	/**
	 * Get support broadcast element
	 * @returns {*}
	 */
	get bcast() {
		return this._dom_obj;
	}

	/**
	 * fire --- Fire a custom event
	 * @param el DOM element event to fire event from
	 * @param type A string representing the name of the event.
	 * @param obj Send a custom object or pass "detail", optional and defaulting to null, of any type, containing an event-dependent value associated with the event. This is available to the handler using the CustomEvent.detail property.
	 * @returns {boolean|*}
	 * @example
	 * Evts.fire(mapbox_map, Evts.ON_MAP_BLADE_NAVIGATE, {
	 *  direction: "Down",
	 *  autoplay: true
	 * })
	 */
	static fire(el, type, obj = undefined) {
		return el.dispatchEvent(new CustomEvent(type,
			obj ? {detail: obj} : null
		));
	}

	/**
	 * addHandlers --- Add event handlers for view
	 */
	addHandlers() {
		console.log(`${this._name} > addHandlers`);
		this.bcast.addEventListener(ThemeFullBackgroundCarousel.EVTS.PREVIOUS, (evt) => this.onThemeFullBackgroundCarousel(evt));
		this.bcast.addEventListener(ThemeFullBackgroundCarousel.EVTS.NEXT, (evt) => this.onThemeFullBackgroundCarousel(evt));
		this._prev.addEventListener('click', (evt) => {this.previous()});
		this._next.addEventListener('click', (evt) => {this.next()});
	}

	addEventListener(listenerName, cb) {
		this._dom_obj.addEventListener(listenerName, cb);
	}

	dispatchEvent(event) {
		this._dom_obj.dispatchEvent(event);
	}

	/**
	 * onThemeFullBackgroundCarousel --- Handle Carousel events
	 * @param evt
	 */
	onThemeFullBackgroundCarousel(evt) {
		// console.log(evt);
		// if (!evt.detail) return;
		// console.log(evt)
		switch (evt.type) {
			case ThemeFullBackgroundCarousel.EVTS.NEXT:
				console.log(`${this._name} > onThemeFullBackgroundCarousel > ${evt.type}`);
				this._slider.next();
				break;
			case ThemeFullBackgroundCarousel.EVTS.PREVIOUS:
				console.log(`${this._name} > onThemeFullBackgroundCarousel > ${evt.type}`);
				this._slider.prev();
				break;
			default:
				console.warn(`${this._name} > onThemeFullBackgroundCarousel > No matching case for = ${evt.type}`);
		}
	}

	/**
	 * next --- Advance to the next slide in the carousel
	 * @param content
	 */
	next(content) {
		ThemeFullBackgroundCarousel.fire(this.bcast, ThemeFullBackgroundCarousel.EVTS.NEXT, content);
	}

	/**
	 * previous --- Move to the previous slide in the carousel
	 */
	previous() {
		console.log(`${this._name} > previous`, this.bcast);
		ThemeFullBackgroundCarousel.fire(this.bcast, ThemeFullBackgroundCarousel.EVTS.PREVIOUS, undefined);
	}
}

export { ThemeFullBackgroundCarousel };
